import {Channel} from "@hosttools/core/shared/model/channel";
import type {Listing, ListingChannel} from "@hosttools/frontend/models/listing";
import type React from "react";
import {memo, useEffect, useState} from "react";

import Select from "@/client/components/Select";

export type PriceSourceOption = {
    value: Required<Listing>["priceSource"];
    label: string;
};

type Props = {
    channels: ListingChannel[];
    selectedValue?: Listing["priceSource"];
    isDisabled?: boolean;
    onSelectedOption: (selectedOption: PriceSourceOption | null) => void;
};

const defaultOptions = [
    {
        value: "Amount" as const,
        label: "Set Amount"
    }
];
const SelectPriceSource: React.FC<Props> = ({
    selectedValue,
    isDisabled,
    channels,
    onSelectedOption
}) => {
    const [selectedOption, setSelectedOption] = useState<PriceSourceOption | null>(null);
    const [options, setOptions] = useState<PriceSourceOption[]>(defaultOptions);

    useEffect(() => {
        const newOptions: PriceSourceOption[] = [
            ...defaultOptions,
            {
                value: "PriceLabs" as const,
                label: "PriceLabs"
            },
            {
                value: "Beyond Pricing" as const,
                label: "Beyond Pricing"
            }
        ];
        if (
            selectedValue === Channel.HomeAway ||
            (channels.length > 1 && channels.includes(Channel.HomeAway))
        ) {
            newOptions.push({
                value: Channel.HomeAway,
                label: "VRBO"
            });
        }
        if (
            selectedValue === Channel.Houfy ||
            (channels.length > 1 && channels.includes(Channel.Houfy))
        ) {
            newOptions.push({
                value: Channel.Houfy,
                label: "Houfy"
            });
        }
        let selectedOption = newOptions.find(option => {
            return option.value === selectedValue;
        });
        if (!selectedOption) {
            [selectedOption] = newOptions;
            onSelectedOption(selectedOption);
        }
        setOptions(newOptions);
        setSelectedOption(selectedOption);
    }, [selectedValue, channels, onSelectedOption]);

    return (
        <Select
            isDisabled={isDisabled || options.length === 1}
            options={options}
            value={selectedOption}
            onChange={onSelectedOption}
        />
    );
};

export default memo(SelectPriceSource);
